import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Page } from '../page.model';
import { AppNotification } from './notification.models';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  private base(): string {
    return `/api/t/${this.auth.currentTenant()}/notificacoes`;
  }

  feed(page = 0, size = 15): Observable<Page<AppNotification>> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<Page<AppNotification>>(this.base(), { params });
  }

  unreadCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.base()}/nao-lidas`);
  }

  markRead(id: number): Observable<void> {
    return this.http.post<void>(`${this.base()}/${id}/lida`, {});
  }

  markAllRead(): Observable<void> {
    return this.http.post<void>(`${this.base()}/ler-todas`, {});
  }
}
